import { View } from 'react-native';
import { Pressable } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { styles } from './OverlayBackdrop.styles';

export function OverlayBackdrop({
  onDismiss,
  animated,
  delay = true,
}: {
  onDismiss?: () => void;
  animated?: boolean;
  delay?: boolean;
}) {
  return (
    <Pressable className={styles.root} onPress={onDismiss}>
      {animated ? (
        <Animated.View
          entering={FadeIn}
          exiting={FadeOut.delay(delay ? 100 : 0)}
          className={styles.content}
        />
      ) : (
        <View className={styles.content} />
      )}
    </Pressable>
  );
}
